export default __webpack_public_path__ + "static/media/four_of_pentacles.df9bf26b.png";